import React, { useMemo } from 'react';
import DropDownSelect from '../dropDownSelect';
import FilterValueInput from './filterValueInput';
import { useAppSelector } from '../../store/hooks';
import { selectSearchOptions } from '../../store/slices/datagridSlice';
import {
    convertKeyToLabel,
    convertLabelToKey,
} from '../../utilities/stringHelpers';
import { colors } from '../../constants';
import { RemoveIcon } from '../../icons';
import { nanoid } from 'nanoid';

// to do: move to helper?
function getDefaultOperator(searchOptions, table, field) {
    const type =
    searchOptions && table && field ? searchOptions[table][field].type : 'text';
    return type === 'enum' ? 'in' : '=';
}

const FilterEditField = ({ onFieldChange, onRemove, values = null }) => {
    const searchOptions = useAppSelector(selectSearchOptions);

    const filter = useMemo(() => {
        return {
            id: values ? values.id : nanoid(),
            table: values ? values.fieldName.split('.')[0] : '',
            field: values ? values.fieldName.split('.')[1] : '',
            operator: values ? values.operator : '',
            value: values ? values.value : '',
        };
    }, [values]);

    const tableChoices = useMemo(
        () =>
            searchOptions
                ? Object.keys(searchOptions).map((t) => convertKeyToLabel(t))
                : [],
        [searchOptions]
    );

    const fields = useMemo(
        () =>
            searchOptions && filter.table
                ? [
                    ...Object.keys(searchOptions[filter.table]).map((f) =>
                        convertKeyToLabel(f)
                    ),
                ]
                : [],
        [filter.table]
    );

    const handleTableChange = (selection) => {
        onFieldChange({
            id: filter.id,
            fieldName: `${convertLabelToKey(selection)}.`,
            operator: '',
            value: '',
        });
    };

    const handleFieldSelect = (v) => {
        const field = convertLabelToKey(v);
        onFieldChange({
            id: filter.id,
            fieldName: `${filter.table}.${field}`,
            operator: '',
            value: '',
        });
    };

    const workingValue = values || {
        id: filter.id,
        fieldName: filter.field,
        operator: getDefaultOperator(searchOptions, filter.table, filter.field),
        value: '',
    };

    const selectedTableLabel = filter.table
        ? convertKeyToLabel(filter.table)
        : null;

    const handleRemove = () => {
        onRemove(filter.id);
    };

    return (
        <div className="w-100 mb-1 pe-2 d-flex flex-column flex-md-row align-items-center rounded shadow-sm searchFormField">
            <div className="searchSelect" style={{ minWidth: '200px' }}>
                <DropDownSelect
                    options={tableChoices}
                    selected={selectedTableLabel}
                    onSelect={handleTableChange}
                    label="Select Table"
                    buttonStyling={{ height: '35px' }}
                />
            </div>
            <div className="searchSelect">
                {filter.table && (
                    <DropDownSelect
                        options={fields}
                        selected={convertKeyToLabel(filter.field)}
                        onSelect={handleFieldSelect}
                        label="Select Field"
                        buttonStyling={{ height: '35px' }}
                    />
                )}
            </div>
            <div className="w-100 d-flex gap-1 align-items-center searchSelect">
                {filter.field && (
                    <FilterValueInput
                        definition={{
                            category: filter.table,
                            name: filter.field,
                            ...searchOptions[filter.table][filter.field],
                        }}
                        value={workingValue}
                        onFieldChange={onFieldChange}
                    />
                )}
                {!!filter.table && (
                    <button
                        className="btn ms-auto p-0 d-flex align-items-center"
                        style={{ background: colors.goldwood }}
                        onClick={handleRemove}
                    >
                        <RemoveIcon color="white" size="16px" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default FilterEditField;
